export const SAVE_CENTER = 'SAVE_CENTER';
export const REMOVE_CENTER = 'REMOVE_CENTER';
